
import { Component, Prop, Vue } from 'vue-property-decorator';

interface InputEvent extends Event {
  target: HTMLInputElement;
}

  @Component
export default class Input extends Vue {
  @Prop(String) readonly placeholder!: string;

  @Prop(String) readonly value!: string;

  listeners = {
    ...this.$listeners,
    input: (event: InputEvent) => this.handleInput(event.target.value),
  }

  handleInput(value: string) {
    this.$emit('input', value);
  }
}
